import React from "react";
import EventFeedItem from "../components/EventFeedItem";

const EventsSearchResult: React.FC<JQI.EventsSearchResultProps> = (props) => {
  return (
    <EventFeedItem {...props} />
  )
};

export default EventsSearchResult;